import { PassiveTool } from '../tool-base-types';
import { LevelDesignerElementBase } from '../../elements/element-base';
import { LevelDesignerComponent } from '../../level-designer/level-designer.component';
import { ToolType } from '../tool';
import { ToolGroup } from '../tool-group';

export abstract class AlignmentToolBase extends PassiveTool {
    constructor(
        canvas: HTMLCanvasElement, 
        levelDesigner: LevelDesignerComponent,
        toolGroup: ToolGroup,
        iconPath: string
    ) {
        super(canvas, levelDesigner, toolGroup, ToolType.Toggle, iconPath);
    }

    protected getBoundingBoxes(elements: LevelDesignerElementBase[]): Array<{element: LevelDesignerElementBase, box: {x: number, y: number, width: number, height: number}}> {
        return elements.map(element => ({
            element,
            box: element.getBoundingBox()
        }));
    }

    public override onSelectionChanged(elements: LevelDesignerElementBase[]): void {
        // No special handling needed
    }

    public override onKeyPress(key: string): void {}
} 
